import React from 'react';
import { ArrowLeft, Home, Play } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const coursesCategories = [
  {
    id: 'bazi',
    title: '八字命理',
    desc: '八字入门到实战',
    color: 'from-orange-500 to-amber-500',
    count: 0
  },
  {
    id: 'liuyao',
    title: '六爻预测',
    desc: '六爻八卦实战教学',
    color: 'from-teal-500 to-cyan-500',
    count: 0
  },
  {
    id: 'qimen',
    title: '奇门遁甲',
    desc: '奇门遁甲高级课程',
    color: 'from-blue-500 to-indigo-500',
    count: 0
  },
  {
    id: 'fengshui',
    title: '风水堪舆',
    desc: '阳宅阴宅风水学',
    color: 'from-green-500 to-emerald-500',
    count: 0
  }
];

const CoursesList = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-rose-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          {/* 返回按钮和首页链接 */}
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-red-800 hover:text-red-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              返回
            </button>
            <Link
              to="/"
              className="flex items-center text-red-800 hover:text-red-600 transition-colors"
            >
              <Home className="w-5 h-5 mr-2" />
              首页
            </Link>
          </div>

          <h1 className="text-4xl font-bold text-center text-red-900 mb-4 font-serif">
            易 学 视 频 课 程
          </h1>
          <p className="text-center text-gray-500 mb-12">名师讲解，实战应用</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {coursesCategories.map((item) => (
              <div
                key={item.id}
                className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden cursor-pointer"
                onClick={() => {
                  // 暂未开放，显示提示
                }}
              >
                <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${item.color} flex items-center justify-center mr-4`}>
                        <Play className="w-6 h-6 text-white ml-1" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-1">{item.title}</h3>
                        <p className="text-gray-500 text-sm">{item.desc}</p>
                      </div>
                    </div>
                    <span className="text-gray-400 text-sm">{item.count} 个课程</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-500">更多课程正在整理中，敬请期待...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesList;
